import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
const firebaseConfig = {
  apiKey: "AIzaSyCgNYl8rgnH1DZHRuL-nuQYfFgEXh08swo",
  authDomain: "sd-industrial-surplus.firebaseapp.com",
  projectId: "sd-industrial-surplus",
  storageBucket: "sd-industrial-surplus.firebasestorage.app",
  messagingSenderId: "124511304596",
  appId: "1:124511304596:web:6869c6b5fab5c2e965ad81",
  measurementId: "G-R86Z3G9MHM"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Comment out for testing without emulators
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
//   connectFirestoreEmulator(db, 'localhost', 8080);
//   connectStorageEmulator(storage, 'localhost', 9199);
// }